import React from 'react';
import { trans } from '../utils';

/**
 * Chat Header - Panel title, context indicator, and close button
 */
const ChatHeader = ({ onClose, contextDescription, onNewChat }) => {
  return (
    <header className="chat-header">
      <div className="chat-header-title">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
        <h2>{trans('Chat Assistant')}</h2>
      </div>
      
      <div className="chat-header-actions">
        {contextDescription && (
          <span className="chat-context-pill" title={contextDescription}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            {contextDescription.length > 20 ? contextDescription.substring(0, 20) + '...' : contextDescription}
          </span>
        )}
        
        {onNewChat && (
          <button
            className="chat-close-button"
            onClick={onNewChat}
            aria-label={trans('New conversation')}
            title={trans('New conversation')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>
        )}
        
        <button
          className="chat-close-button"
          onClick={onClose}
          aria-label={trans('Close chat')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
    </header>
  );
};

export default ChatHeader;
